/// <reference path="../../BaseNew/GAdmSeznamBase.ts"/>

namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class SeznamSchvalovaciSablonaEpk extends GContentBase<SeznamSchvalovaciSablonaEpkObj> {
        private seznamObj: SeznamSchvalovaciSablonaEpkObj & GContent;

        onContentReady() {
            this.seznamObj = $.extend(this as GContent, new SeznamSchvalovaciSablonaEpkObj());
            this.seznamObj.createBase({
                content: this,
                contentName: "seznamSchvalovaciSablonaEpkNew",
                contentCaption: "jres:33000899", //RC 33000899 : Schvalovací šablony EPK
                dataListDescriptor: this.dataListDescription,
                comparatorSettings: {
                    itemTemplate: "{ixs_ssa}"
                },
                gridSettings: {
                    columnOrder: "nazev,zkratka,ktg_typ_txt,var_proc_txt,sch_wfl_typ_txt,ico,ixs_ssa,dat_od,dat_do,dat_zmena,zmenu_prov_txt"
                }
            })
            this.seznamObj.createBaseMenuBarActions();
            this.seznamObj.createFilter();
            this.seznamObj.createGrid();
        }
    }

    export class SeznamSchvalovaciSablonaEpkObj extends GAdmSeznamBase {

        create() {

        }

        openDetail(data: any, isNew: boolean) {
            $.content().navigate(["Gordic.Adm.WebControls.DetailSchvalovaciSablonaEpk", {
                currentFilter: this.filterData,
                gridRc: new Gordic.Components.GridRC(this.grid)
            }], {
                ID: "DetailSchvalovaciSablonaEpk",
                newRecord: isNew,
                ixs_ssa: isNew == true ? null : data.ixs_ssa
            })
        }

        createActions(): { [akceName: string]: GAction | GActionParamsDefObj } | null {
            return {
                actSeznamFunkceSchvalovaciSablonaEpk: {
                    icon: "fa-link",
                    caption: "jres:33000896", //RC 33000896 : Přiřazená funkční místa
                    run: (ev, ctx) => {
                        this.openSeznamFunkceSchvalovaciSablonyEpk();
                    }
                },
                actSeznamSchvalovaciSablonaEpkUkony: {
                    icon: "fa-link",
                    caption: "jres:33000903",
                    run: (ev, ctx) => {
                        this.openSeznamSchvalovaciSablonaEpkUkony();
                    }
                },
                actSeznamTypyDokumentuSchvalovaciSablonyEpk: {
                    icon: "fa-link",
                    caption: "jres:33000906", //RC 33000906 : Přiřazené typy dokumentů
                    run: (ev, ctx) => {
                        this.openSeznamTypyDokumentuSchvalovaciSablonyEpk();
                    }
                }
            }
        }

        createBaseMenuBarActions() {
            this.cnt.menuBar(this.cnt.actions.createBar(["actOpenDetail*", "actNewDetail*", "actAddToComparison*", "actOpenDialogVyberovaSkupina*", {
                favorite: true, type: "static", caption: "jres:33000138", icon: "fa-link", children: [
                    { action: this.cnt.actions.actSeznamFunkceSchvalovaciSablonaEpk },
                    { action: this.cnt.actions.actSeznamSchvalovaciSablonaEpkUkony },
                    { action: this.cnt.actions.actSeznamTypyDokumentuSchvalovaciSablonyEpk }
                ]
            }]))
        }

        createContextMenu(): MenuParams[] {
            return this.cnt.actions.createBar([
                "actOpenDetail*",
                "actOpenDialogVyberovaSkupina*",
                "actSeznamFunkceSchvalovaciSablonaEpk*",
                "actSeznamSchvalovaciSablonaEpkUkony*",
                "actSeznamTypyDokumentuSchvalovaciSablonyEpk*"
            ])
        }

        createFilterForm() {

        }

        userhardDefaultFilter(hardFilter: any): any {
            return hardFilter;
        }

        collectData(data: any) {

        }

        applydata(filterData: any) {
            this.cnt.isl.SchvalovaciSablonaEpk.list({ filters: filterData }).getView().done((data) => {
                this.setPlatnostColumn(data)
                this.view = data;
                this.grid.ggrid('setData', this.view);
            });
        }

        selectionGridAct(objArr: IGGridSelection<any>) {
            this.cnt.actions.actSeznamFunkceSchvalovaciSablonaEpk?.update({ enabled: objArr.count == 1 })
            this.cnt.actions.actSeznamSchvalovaciSablonaEpkUkony?.update({ enabled: objArr.count == 1 })
            this.cnt.actions.actSeznamTypyDokumentuSchvalovaciSablonyEpk?.update({ enabled: objArr.count == 1 })
        }

        getSxs(data): IGAdmGridSxs {
            return {
                sxs: `${data.ixs_ssa}`,
                nazev: data["nazev"]
            }
        }

        private openSeznamFunkceSchvalovaciSablonyEpk() {
            const activeRow = this.grid.ggrid("activeRow");
            if (activeRow)
                this.cnt.navigate("Gordic.Adm.WebControls.SeznamFunkceSchvalovaciSablonyEpk", { ixs_ssa: activeRow.ixs_ssa })
        }

        private openSeznamSchvalovaciSablonaEpkUkony() {
            const activeRow = this.grid.ggrid("activeRow");
            if (activeRow)
                this.cnt.navigate("Gordic.Adm.WebControls.SeznamSchvalovaciSablonaEpkUkony", { ixs_ssa: activeRow.ixs_ssa })
        }

        private openSeznamTypyDokumentuSchvalovaciSablonyEpk() {
            const activeRow = this.grid.ggrid("activeRow");
            if (activeRow)
                this.cnt.navigate("Gordic.Adm.WebControls.SeznamTypyDokumentuSchvalovaciSablonyEpk", { ixs_ssa: activeRow.ixs_ssa })
        }
    }
}
